import { useEffect, useRef, useState } from "react";
import styles from "../styles/Forms.module.css";
import stylesTabel from "../styles/Tabel.module.css";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { FaRegEdit, FaUserAlt } from "react-icons/fa";
import resha__ from "../images/resha.png";
import { MdDeleteOutline } from "react-icons/md";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import {
  addCompanies,
  deleteCompanies,
  getCompanies,
  updateCompanies,
} from "../store/EmployeesSlice";

import { Password } from "primereact/password";
import { Calendar } from "primereact/calendar";
import FormatDate from "./../components/DateFunctions/FormatDate";
import ar from "react-phone-number-input/locale/ar";
import PhoneInput from "react-phone-number-input";
import ReturnToFormate from "./../components/DateFunctions/ReturnToFormate";
const Companies = () => {
  const { CompaniesArray } = useSelector((state) => state.EmployeesSlice);
  const [fileDialog, setFileDialog] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!CompaniesArray) {
      dispatch(getCompanies());
    }
  }, [dispatch, CompaniesArray]);
  const toast = useRef(null);
  const Success = () => {
    toast.current.show({
      severity: "success",
      summary: "تم الحفظ بنجاح",
    });
  };
  const Error = (mess) => {
    toast.current.show({
      severity: "error",
      summary: `${mess}`,
      life: 3000,
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ar_name: "",
      en_name: "",
      number: "",
      password: "",
      email: "",
      payment_finished_date: null,
      update: false,
      id: null,
    },
    validate: (data) => {
      let errors = {};
      if (!data.ar_name) {
        errors.ar_name = "  الاسم بالعربي مطلوب";
      }
      if (!data.ar_name) {
        errors.ar_name = "  الاسم بالعربي مطلوب";
      }
      if (!data.number) {
        errors.number = "   الهاتف مطلوب";
      }
      if (!data.payment_finished_date) {
        errors.payment_finished_date = "   تاريخ إنتهاء الدفع مطلوب";
      }
      if (!data.email) {
        errors.email = " البريد الالكتروني مطلوب";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)
      ) {
        errors.email = "  البريد الالكتروني غير صحيح";
      }
      if (!data.password && !data.update) {
        errors.password = "الرقم السرى مطلوب";
      }
      return errors;
    },
    onSubmit: (data) => {
      if (data) {
        const Data = {
          ...data,
          payment_finished_date: data?.payment_finished_date
            ? FormatDate(data?.payment_finished_date)
            : null,
        };
        if (data.update) {
          dispatch(updateCompanies(Data))
            .unwrap()
            .then((res) => {
              Clear();
            })
            .catch((err) => {
              Error(err[0]);
            });
        } else {
          dispatch(addCompanies(Data))
            .unwrap()
            .then((res) => {
              Clear();
            })
            .catch((err) => {
              Error(err[0]);
            });
        }
      }
    },
  });

  const Clear = () => {
    Success();
    formik.resetForm();
    dispatch(getCompanies());
    setFileDialog(false);
  };
  const isFormFieldInvalid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return isFormFieldInvalid(name) ? (
      <small className="p-error">{formik.errors[name]}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };
  const accept = (data, type) => {
    if (type === "delete") {
      dispatch(deleteCompanies(data))
        .unwrap()
        .then(() => {
          dispatch(getCompanies());
          Success();
        });
    } else {
      dispatch(updateCompanies(data))
        .unwrap()
        .then(() => {
          dispatch(getCompanies());
          Success();
        });
    }
  };
  const reject = () => {
    toast.current.show({
      severity: "warn",
      detail: "تم الالغاء ",
      life: 3000,
    });
  };
  const confirm2 = (data, type) => {
    confirmDialog({
      header: type === "delete" ? "تأكيد الحذف" : "تأكيد تغير الحالة ",
      acceptClassName: "p-button-danger",
      rejectClassName: "rejectClassName",
      rejectLabel: "رفض",
      acceptLabel: "نعم",
      accept: () => accept(data, type),
      reject,
      className: "dialog_Pop",
    });
  };

  const StateBody = (rowData) => {
    return (
      <div className="StatusBtn6">
        {/* <InputSwitch
          checked={rowData?.status === 1 ? true : false}
          onChange={(e) => {
            const data = {
              id: rowData.id,
              status: +e.value,
            };
            confirm2(data, "update");
          }}
        /> */}
        <button
          className="  edite_btn"
          onClick={() => {
            formik.setValues({
              update: true,
              id: rowData.id,
              ar_name: rowData.ar_name,
              en_name: rowData.en_name,
              email: rowData?.email,
              number: rowData?.number,
              payment_finished_date: ReturnToFormate(
                rowData?.payment_finished_date
              ),
            });
            setFileDialog(true);
          }}
        >
          <FaRegEdit />
        </button>
        <button
          className=" delete_btn"
          onClick={() => {
            confirm2(rowData.id, "delete");
          }}
        >
          <MdDeleteOutline />
        </button>
      </div>
    );
  };

  return (
    <div className="Tabel_container">
      <Toast ref={toast} position="top-left" />
      <ConfirmDialog />

      <div className="flex justify-content-between align-items-center  tilte_page">
        <p>قائمة الشركات</p>
        <div className="StatusBtn ">
          <button
            className=" add_btn"
            onClick={() => {
              formik.resetForm();
              setFileDialog(true);
            }}
          >
            اضافة شركة
          </button>
        </div>
      </div>
      <div className={stylesTabel.Tabel}>
        <DataTable
          tableStyle={{ minWidth: "50rem" }}
          value={CompaniesArray}
          className={`${stylesTabel.dataTabel}`}
          rows={10}
          dataKey="id"
          responsiveLayout="scroll"
          emptyMessage="  لا يوجد بيانات متاحة  "
          stripedRows
          paginator
        >
          <Column field="id" header="#" />
          <Column field="ar_name" header="الاسم باللغة العربية" />
          <Column field="en_name" header="الاسم باللغة الانجليزية" />
          <Column field="email" header="البريد الإلكتروني" />
          <Column field="number" header=" الهاتف" />
          <Column field="number" header=" الهاتف" />
          <Column body={StateBody} header="  تعديل " />
        </DataTable>
      </div>

      <Dialog
        visible={fileDialog}
        style={{ minWidth: "50vw" }}
        onHide={() => {
          if (!fileDialog) return;
          setFileDialog(false);
          formik.resetForm();
        }}
        header={
          <div className="heade_dialog">
            <FaUserAlt />
            اضافة شركة
          </div>
        }
      >
        <form
          onSubmit={formik.handleSubmit}
          className={styles.Signup_form_container}
        >
          <img src={resha__} alt={"resha"} className={styles.resha_dialog} />
          <div className="grid  justify-content-between number_length  align-items-center   ">
            <div className="col-12 md:col-6 ">
              <div className={`${styles.inputFormik}`}>
                <div className={styles.Signup_container}>
                  <label> الاسم باللغة العربية</label>
                  <InputText
                    id="ar_name"
                    name="ar_name"
                    className={classNames({
                      "p-invalid": isFormFieldInvalid("ar_name"),
                    })}
                    value={formik.values.ar_name}
                    onChange={(e) => {
                      formik.setFieldValue("ar_name", e.target.value);
                    }}
                  />
                </div>
                {getFormErrorMessage("ar_name")}
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className={`${styles.inputFormik}`}>
                <div className={styles.Signup_container}>
                  <label> الاسم باللغة الانجليزية</label>
                  <InputText
                    id="en_name"
                    name="en_name"
                    className={classNames({
                      "p-invalid": isFormFieldInvalid("en_name"),
                    })}
                    value={formik.values.en_name}
                    onChange={(e) => {
                      formik.setFieldValue("en_name", e.target.value);
                    }}
                  />
                </div>
                {getFormErrorMessage("en_name")}
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className={`${styles.inputFormik}`}>
                <div className={styles.Signup_container}>
                  <label> الهاتف </label>

                  <PhoneInput
                    limitMaxLength
                    labels={ar}
                    international
                    countryCallingCodeEditable={false}
                    onChange={(value) => {
                      formik.setFieldValue("number", value);
                    }}
                    name="number"
                    className={classNames({
                      "p-invalid": isFormFieldInvalid("number"),
                    })}
                    value={formik.values.number}
                    defaultCountry="KW"
                    countries={["KW", "AE", "SA"]}
                  />
                </div>
                {getFormErrorMessage("number")}
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className={`${styles.inputFormik}`}>
                <div className={styles.Signup_container}>
                  <label> تاريخ إنتهاء الدفع</label>

                  <Calendar
                    name="payment_finished_date"
                    onChange={(e) => {
                      formik.setFieldValue("payment_finished_date", e.value);
                    }}
                    className={classNames({
                      "p-invalid": isFormFieldInvalid("payment_finished_date"),
                    })}
                    value={formik.values.payment_finished_date}
                    dateFormat="yy-mm-dd"
                    placeholder={"DD/MM//YYYY"}
                  />
                </div>
                {getFormErrorMessage("payment_finished_date")}
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className={`${styles.inputFormik}`}>
                <div className={styles.Signup_container}>
                  <label> البريد الإلكتروني</label>
                  <InputText
                    id="email"
                    name="email"
                    className={classNames({
                      "p-invalid": isFormFieldInvalid("email"),
                    })}
                    value={formik.values.email}
                    onChange={(e) => {
                      formik.setFieldValue("email", e.target.value);
                    }}
                  />
                </div>
                {getFormErrorMessage("email")}
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className={`${styles.inputFormik}`}>
                <div className={styles.Signup_container}>
                  <label> التخصص</label>
                  <Password
                    placeholder="كلمة المرور"
                    toggleMask
                    name="password"
                    className={`${classNames({
                      "p-invalid": isFormFieldInvalid("password"),
                    })} w-full `}
                    value={formik.values.password}
                    feedback={false}
                    onChange={(e) => {
                      formik.setFieldValue("password", e.target.value);
                    }}
                  />
                </div>
                {getFormErrorMessage("password")}
              </div>
            </div>
          </div>
          <div className={`${styles.next} gap-3`}>
            <button name="save" type="submit">
              حفظ
            </button>
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default Companies;
